import {AbilityBuilder, Ability} from '@casl/ability';
import Rules from './rules';

export default function defineAbilityFor(user) {
    const {build} = Rules(new AbilityBuilder(Ability), user);
    return build();
}